import { SERVICE_CONFIGS } from "./services"

const isFile = (value) => typeof File !== "undefined" && value instanceof File
const bundleSlots = ["cover", "description", "narration"]

// A File becomes a saved name only when this successful request actually sent it.
export function sentFiles(snapshot, payload) {
  const wire = payload.project_posting || {}
  const postings = []
  for (const [service, values] of Object.entries(snapshot.postings || {})) {
    const postingKey = SERVICE_CONFIGS[service]?.postingKey || `${service}_posting`
    const attrs = wire[`${postingKey}_attributes`] || {}
    for (const [key, file] of Object.entries(values || {})) {
      if (isFile(file) && attrs[key] === file) postings.push([service, key, file])
    }
  }

  const bundle = []
  for (const slot of bundleSlots) {
    const file = snapshot.bundleExtras?.files?.[slot]
    if (isFile(file) && wire[`bundle_${slot}_file`] === file) bundle.push([slot, file])
  }
  return { postings, bundle }
}

export function acknowledgeFiles(state, sent) {
  let postings = state.postings
  let files = state.bundleExtras?.files
  for (const [service, key, file] of sent.postings) {
    if (postings?.[service]?.[key] !== file) continue
    if (postings === state.postings) postings = { ...postings }
    postings[service] = { ...postings[service], [key]: { name: file.name } }
  }
  for (const [slot, file] of sent.bundle) {
    if (files?.[slot] !== file) continue
    if (files === state.bundleExtras.files) files = { ...files }
    files[slot] = { name: file.name }
  }
  if (postings === state.postings && files === state.bundleExtras?.files) return state
  return {
    ...state,
    postings,
    bundleExtras: { ...state.bundleExtras, files },
  }
}

// A save already queued behind an upload may have captured the old File state.
// Check identity at its turn in the save queue, after the first request succeeds.
export function omitSavedBundleFiles(payload, acknowledged) {
  const wire = payload.project_posting
  if (!wire) return payload
  let next = wire
  for (const slot of bundleSlots) {
    const key = `bundle_${slot}_file`
    if (isFile(wire[key]) && wire[key] === acknowledged[slot]) {
      if (next === wire) next = { ...wire }
      delete next[key]
    }
  }
  return next === wire ? payload : { ...payload, project_posting: next }
}
